import { render, staticRenderFns } from "./GalleryItem.html?vue&type=template&id=0b1a1012&scoped=true&external"
import script from "./GalleryItem.js?vue&type=script&lang=js&external"
export * from "./GalleryItem.js?vue&type=script&lang=js&external"
import style0 from "./GalleryItem.scss?vue&type=style&index=0&id=0b1a1012&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a1012",
  null
  
)

export default component.exports